import styles from "./RelatorioDeTotais.module.css";
import Container from "../../../../components/components-ui/Container/Container";
import Loading from "../../../../components/components-ui/Loading/Loading";
import Button from "../../../../components/components-ui/Button/Button";
import { Table } from "../../../../components/Table";
import { Grid, Col } from "../../../../components/Grid";
import api from "../../../../services/Api";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SelectSearch } from "../../../../components/components-ui/SelectSearch/SelectSearch";
import InputClear from "../../../../components/components-ui/InputClear/InputClear";
import { Box, Modal } from "@mui/material";
import ModalRelatorioDeTotais from "./Modal/ModalRelatorioTotais";
import { useOrdenacao } from "../../../../utils/useOrdenacao";
import { useVerificaPermissao } from "../../../../utils/verificaPermissao";
import { AuthContext } from "../../../../Provider/AuthContext";

const formatterNumber = (number) => {
  const formatted = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(number);

  return formatted;
};

// LINKS
const API_LISTA_EMISSOR = `/usuario/view`;
const API_RELATORIO_TOTAIS = "/relatorio/relatoriototais";

// Colunas da tabela
const columns = [
  {
    column: "Data balança",
    key: "DataBalancaFormatada",
  },
  {
    column: "ID Rota",
    key: "IDOC",
  },
  {
    column: "Freguesia",
    key: "Freguesia",
  },
  {
    column: "Placa",
    key: "Placa",
  },
  {
    column: "Peso Bruto",
    key: "PesoBruto",
  },
  {
    column: "Total Descarte",
    key: "TotalDescarte",
  },
  {
    column: "Total Balança",
    key: "TotalBalanca",
  },
  {
    column: "Total Código Cliente",
    key: "TotalCodigoCliente",
  },
  {
    column: "Total do Relatório",
    key: "TotalDoRelatorio",
  },
  {
    column: "Status",
    key: "Status",
  },
];

export default function RelatorioDeTotais() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();

  const [dadosRelatorio, setDadosRelatorio] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filterTable, setFilterTable] = useState("&id_status=1");
  const [openModal, setOpenModal] = useState(false);
  const [idBalanca, setIdBalanca] = useState("");
  const [somas, setSomas] = useState({
    totalBalanca: 0,
    totalDescarte: 0,
    totalBruto: 0,
    totalRelatorio: 0,
  });

  const { dados, ordenar, ordem, setDados } = useOrdenacao(
    dadosRelatorio,
    setDadosRelatorio
  );

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela de relatorio de totais
    verificaPermissao(idTipoUsuario, 69);
  }, []);

  const getRelatorio = async () => {
    setShowLoading(true);
    await api
      .get(API_RELATORIO_TOTAIS + `?page=${currentPage}${filterTable}`)
      .then((res) => {
        setDadosRelatorio(res.data.data);
        setTotalPages(res.data.totalPages);
        setCurrentPage(res.data.currentPageNumber);
        setSomas((prev) => ({
          totalBalanca: res.data.totalBalanca,
          totalBruto: res.data.pesoBruto,
          totalRelatorio: res.data.totalRelatorio,
          totalDescarte: res.data.pesoDescarte,
        }));
      })
      .catch((error) => console.log(error));
    setShowLoading(false);
  };

  useEffect(() => {
    getRelatorio();
  }, [currentPage, filterTable]);

  async function filter(values) {
    let data = `${
      values?.dataFreguesiaDe
        ? `&data_balanca_de=${values?.dataFreguesiaDe}`
        : ""
    }`;
    data =
      data +
      `${
        values?.dataFreguesiaAte
          ? `&data_balanca_ate=${values?.dataFreguesiaAte}`
          : ""
      }`;
    data =
      data +
      `${
        values?.numeroFreguesia ? `&freguesia=${values?.numeroFreguesia}` : ""
      }`;
    data = data + `${values?.status ? `&id_status=${values?.status}` : ""}`;
    data = data + `${values?.idRota ? `&id_oc=${values?.idRota}` : ""}`;

    setCurrentPage(1);
    setFilterTable(data);
  }

  function resetFilters(resetForm, setFieldValue) {
    resetForm();
    setFilterTable("&id_status=1");
    setCurrentPage(1);
  }

  function previewPage() {
    if (currentPage === 1) {
      setCurrentPage(1);
    } else {
      setCurrentPage(currentPage - 1);
    }
  }
  function nextPage() {
    if (currentPage === totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(currentPage + 1);
    }
  }

  const onOpenModalRelatorio = (id) => {
    setIdBalanca(id);
    setOpenModal(true);
  };

  const ValidationSchema = Yup.object().shape({
    dataFreguesiaDe: Yup.date().max(
      new Date(),
      "Não é possível filtrar por uma data futura"
    ),
    dataFreguesiaAte: Yup.string(),
    numeroFreguesia: Yup.string(),
    idRota: Yup.string(),
    status: Yup.string(),
  });

  return (
    <Container>
      <h3>Relatório De Totais</h3>
      <div className={styles.content}>
        <Formik
          initialValues={{
            dataFreguesiaDe: "",
            dataFreguesiaAte: "",
            numeroFreguesia: "",
            idRota: "",
            status: 1,
          }}
          validationSchema={ValidationSchema}
          onSubmit={(values) => filter(values)}
        >
          {({ errors, touched, resetForm, setFieldValue }) => (
            <Form>
              <section className={styles.wrap}>
                <div className={styles.filter_header}>
                  <strong>Filtros</strong>
                  <div style={{ display: "flex", gap: 10 }}>
                    <Button title="Procurar" type="submit" />
                    <Button
                      type="button"
                      title="Limpar filtros"
                      color="tertiary"
                      onClick={() => resetFilters(resetForm, setFieldValue)}
                    />
                  </div>
                </div>
                <Grid>
                  <Col size={2}>
                    <label>Data Freg. De</label>
                    <Field type="date" name="dataFreguesiaDe" />
                    {errors.dataFreguesiaDe && touched.dataFreguesiaDe ? (
                      <span className={styles.alertError}>
                        {errors.dataFreguesiaDe}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Data Freg. Até</label>
                    <Field type="date" name="dataFreguesiaAte" />
                    {errors.dataFreguesiaAte && touched.dataFreguesiaAte ? (
                      <span className={styles.alertError}>
                        {errors.dataFreguesiaAte}
                      </span>
                    ) : null}
                  </Col>

                  <Col size={1}>
                    <label>N° Freguesia</label>
                    <Field type="text" name="numeroFreguesia">
                      {({ field }) => (
                        <InputClear
                          type="text"
                          onClick={() => setFieldValue("numeroFreguesia", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.numeroFreguesia && touched.numeroFreguesia ? (
                      <span className={styles.alertError}>
                        {errors.numeroFreguesia}
                      </span>
                    ) : null}
                  </Col>

                  <Col size={1}>
                    <label>ID Rota</label>
                    <Field type="text" name="idRota">
                      {({ field }) => (
                        <InputClear
                          type="text"
                          onClick={() => setFieldValue("idRota", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.idRota && touched.idRota ? (
                      <span className={styles.alertError}>{errors.idRota}</span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Status</label>
                    <Field
                      component={SelectSearch}
                      name="status"
                      options={[
                        {
                          value: 1,
                          label: "PENDENTE",
                        },
                        {
                          value: 2,
                          label: "ENCERRADO",
                        },
                        {
                          value: 3,
                          label: "CANCELADO",
                        },
                      ]}
                    />
                    {errors.status && touched.status ? (
                      <span className={styles.alertError}>{errors.status}</span>
                    ) : null}
                  </Col>
                </Grid>
              </section>
            </Form>
          )}
        </Formik>
        <div className={styles.container_table}>
          <Table edit columns={columns} onSort={ordenar} ordem={ordem}>
            {!showLoading &&
              dados.map((values) => (
                <tr key={values?.IdBalanca}>
                  <td style={{ cursor: "pointer" }}>
                    <div
                      onClick={() => onOpenModalRelatorio(values?.IdBalanca)}
                    >
                      <i className="fas fa-pencil-alt"></i>
                    </div>
                  </td>
                  <td>{values?.DataBalancaFormatada}</td>
                  <td>{values?.IDOC}</td>
                  <td>{values?.Freguesia}</td>
                  <td>{values?.Placa}</td>
                  <td style={{ textAlign: "right" }}>{values?.PesoBruto}</td>
                  <td style={{ textAlign: "right" }}>
                    {values?.TotalDescarte}
                  </td>
                  <td style={{ textAlign: "right" }}>{values?.TotalBalanca}</td>
                  <td style={{ textAlign: "right" }}>
                    {values?.TotalCodigoCliente}
                  </td>
                  <td style={{ textAlign: "right" }}>
                    {values?.TotalDoRelatorio}
                  </td>
                  <td style={{ textAlign: "left" }}>{values?.Status}</td>
                </tr>
              ))}
          </Table>
          {dados.length == 0 && !showLoading ? (
            <p style={{ textAlign: "center", marginBottom: "20px" }}>
              Nenhuma opção encontrada{" "}
            </p>
          ) : (
            ""
          )}
        </div>
        <div className={styles.loading}>
          <Loading display={showLoading ? "block" : "none"} />
        </div>

        <div className={styles.table_pagination}>
          <div className={styles.table_pagination_buttons}>
            <Button
              disabled={currentPage === 1 ? true : false}
              onClick={() => previewPage()}
            >
              <i style={{ marginRight: 5 }} className="fas fa-chevron-left"></i>
              Voltar
            </Button>
            <span>
              {currentPage} De {totalPages}
            </span>

            <Button
              disabled={
                currentPage === totalPages || totalPages === 0 ? true : false
              }
              onClick={() => nextPage()}
            >
              Próxima
              <i style={{ marginLeft: 5 }} className="fas fa-chevron-right"></i>
            </Button>
          </div>
        </div>

        <div>
          <Box border={1} padding={2} className={styles.box} maxWidth={400}>
            <div className={styles.filter_container}>
              <label>Soma Peso Bruto </label>
              <input
                type="text"
                value={formatterNumber(somas.totalBruto)}
                disabled
              />
            </div>
            <div className={styles.filter_container}>
              <label>Soma Peso Descarte </label>
              <input
                type="text"
                value={formatterNumber(somas.totalDescarte)}
                disabled
              />
            </div>
            <div className={styles.filter_container}>
              <label>Soma Peso Balança </label>
              <input
                type="text"
                disabled
                value={formatterNumber(somas.totalBalanca)}
              />
            </div>
            <div className={styles.filter_container}>
              <label>Soma Relatório </label>
              <input
                type="text"
                disabled
                value={formatterNumber(somas.totalRelatorio)}
              />
            </div>
          </Box>
        </div>
      </div>
      <Modal
        open={openModal}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalRelatorioDeTotais
          idBalanca={idBalanca}
          recarregaRelatorio={getRelatorio}
          closeModal={() => setOpenModal(false)}
        />
      </Modal>
    </Container>
  );
}
